import { z } from "zod";
import { TranslationSchema } from "@/utils/i18n";

export namespace RequestDemo {
  const SelectOptionSchema = z.object({
    id: z.number(),
    title: z.string(),
  });

  export type SelectOption = z.infer<typeof SelectOptionSchema>;

  export const ConfigSchema = z.object({
    api: z.object({
      submit: z.string(),
    }),
    cal: z.object({
      namespace: z.string(),
      calLink: z.string(),
    }),
    roles: SelectOptionSchema.array(),
    goals: SelectOptionSchema.array(),
    translation: TranslationSchema,
  });

  export type Config = z.infer<typeof ConfigSchema>;
}
